import { cx } from '@emotion/css';
import { PropsWithChildren } from 'react';
import { AppPageHeader, AppPageHeaderProps } from './AppPageHeader';

interface AppPageProps extends AppPageHeaderProps {
  containerClassName?: HTMLDivElement['className'];
  contentClassName?: HTMLDivElement['className'];
}

export const AppPage = (props: PropsWithChildren<AppPageProps>) => {
  const { containerClassName, contentClassName, children, ...headerProps } = props;

  return (
    <div className={cx('flex flex-col bg-fill-0 rounded-md', containerClassName)}>
      <AppPageHeader {...headerProps} />
      <div className={cx('p-4 bg-fill-0', contentClassName)}>{children}</div>
    </div>
  );
};
